import GetAppSystemLookupRequestModelBase from '../_generated/modelBases/get-app-system-lookup-request-model-base';

export default class GetAppSystemLookupRequestModel extends GetAppSystemLookupRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
